import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { LoadNoteType } from './load-note-type.model';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import { LocalNote } from './local-note.model';
import { map } from 'rxjs/operators';

@Injectable()
export class LocalNoteService {

  constructor(private http: HttpClient) {
  }

  public addNoteForSelfCarrier(
    loadUuid: string, subject: string, message: string, noteType: LoadNoteType, userEmail: string
  ): Observable<LocalNote> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/local-loads/${loadUuid}/notes/for/carrier/self`;

    const body = { subject, message, note_type_code: noteType.code, created_by: userEmail };

    return this.http.post<void>(url, body, { headers })
      .pipe(
        map((n: any) => LocalNote.fromDto(n))
      );
  }

  public addNoteForCarrier(
    carrier: Carrier, loadUuid: string, subject: string, message: string, noteType: LoadNoteType, userEmail: string
  ): Observable<LocalNote> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/api/local-loads/${loadUuid}/notes/for/carrier/${carrier.id}`;

    const body = { subject, message, note_type_code: noteType.code, created_by: userEmail };

    return this.http.post(url, body, { headers })
      .pipe(
        map((n: any) => LocalNote.fromDto(n))
      );
  }
}
